import { Component } from '@angular/core';

@Component({
  selector: 'app-header-cell-renderer',
  templateUrl: './header-cell-renderer.component.html',
  styleUrls: ['./header-cell-renderer.component.scss']
})
export class HeaderCellRendererComponent {

    constructor() { }
    params: any;
    value: any;

    agInit(params: any): void {
        this.params = params;
        this.value = params.displayName || 'n/a';
    }

    public isNotApplicable(): boolean {
        return this.value === 'n/a';
    }
}
